import React, {useState, useEffect } from 'react'
import IndicatorsPage from '@auteco/pages/GvcPage/IndicatorsPage/IndicatorsPage'
import { getIndicatorsCountry, getIndicatorsRegions, getIndicatorsBosses, getIndicatorsPartners, getIndicatorsQuizzes, getIndicatorsActions, getIndicatorsManagers, getGroupList, getModulesCountry, getPartnerModuleType, getPartnerQuizzesScore, getActionAreas } from 'src/services/GvcServices'




const IndicatorsContainer = () => {
  const [countryInfo, setCountryInfo] = useState({})
  const [regionsInfo, setRegionsInfo] = useState([])
  const [infoManagers, setInfoManagers] = useState([])
  const [bossesInfo, setBossesInfo] = useState([])
  const [bossesInfoDisplayed, setBossesInfoDisplayed] = useState([])
  const [infoPartners, setPartnersInfo] = useState([])
  const [infoPartnersDisplayed, setPartnersInfoDisplayed] = useState([])
  const [infoQuizzes, setInfoQuizzes] = useState([])
  const [infoActions, setInfoActions] = useState([])
  const [modulesCountry, setModulesCountry] = useState([])
  const [groupList, setGroupList] = useState([])
  const [partnerModule, setPartnerModule] = useState([])
  const [partnersQuizzesScore, setPartQuizzesScore] = useState([])
  const [actionsAreas, setActionsAreas] = useState([])

  const fetchInfoCountry = async (params) => {
    const { success, data } = await getIndicatorsCountry(params)
    if (success) {
      setCountryInfo(data)
    }
  }

  const fetchInfoRegions = async (params) => {
    const { success, data } = await getIndicatorsRegions(params)
    if (success) {
      setRegionsInfo(data)
    }
  }

  const fetchInfoManagers = async (params) => {
    const { success, data } = await getIndicatorsManagers(params)
    if (success) {
      setInfoManagers(data)
    }
  }
  const fetchInfoBosses = async (params) => {
    const { success, data } = await getIndicatorsBosses(params)
    if (success) {
      setBossesInfo(data)
      setBossesInfoDisplayed(data)
    }
  }

  const fetchInfoPartners = async (params) => {
    const { success, data } = await getIndicatorsPartners(params)
    if (success) {
      setPartnersInfo(data)
      setPartnersInfoDisplayed(data)
    }
  }

  const fetchInfoQuizzes = async (params) => {
    const { success, data } = await getIndicatorsQuizzes(params)
    if (success) {
      setInfoQuizzes(data)
    }
  }

  const fetchInfoActions = async (params) => {
    const { success, data } = await getIndicatorsActions(params)
    if (success) {
      setInfoActions(data)
    }
  }

  const fetchGroupList = async () => {
    const { success, data } = await getGroupList()
    if (success) {
      setGroupList(data)
    }
  }

  const fetchModulesCountry = async (params) => {
    const { success, data } = await getModulesCountry(params)
    if (success) {
      setModulesCountry(data)
    }
  }

  const fetchPartnerModuleType = async (params) => {
    const { success, data } = await getPartnerModuleType(params)
    if (success) {
      setPartnerModule(data)
    }
  }

  const fetchPartnerQuizzesModules = async (params) => {
    const { success, data } = await getPartnerQuizzesScore(params)
    if (success) {
      setPartQuizzesScore(data)
    }
  }

  const fetchActionsAreas = async (params) => {
    const { success, data } = await getActionAreas(params)
    if (success) {
      setActionsAreas(data)
    }
  }

  const onSubmitInfo = async (params) => {
    fetchInfoCountry(params)
    fetchInfoManagers(params)
    fetchInfoRegions(params)
    fetchInfoBosses(params)
    fetchInfoPartners(params)
    fetchInfoQuizzes(params)
    fetchInfoActions(params)
    fetchModulesCountry(params)
    fetchPartnerModuleType(params)
    fetchPartnerQuizzesModules(params)
    fetchActionsAreas(params)
  }

  const filterBosses = manager => {
    const newInfoBosses = manager === 'todas' ? bossesInfo : bossesInfo.filter(boss => boss.gerente === manager)
    const newInfoPartners =  manager === 'todas' ? infoPartners : infoPartners.filter(partner => partner.gerente === manager)
    setBossesInfoDisplayed(newInfoBosses)
    setPartnersInfoDisplayed(newInfoPartners)
  }
  const filterPartners = boss => {
    const newInfoPartners = boss === 'todas' ? infoPartners : infoPartners.filter(partner => partner.jefe === boss)
    setPartnersInfoDisplayed(newInfoPartners)
  }

  useEffect(() => {
    fetchGroupList()
  },[])
  return (
    <IndicatorsPage
      countryInfo={countryInfo}
      regionsInfo={regionsInfo}
      infoManagers={infoManagers}
      bossesInfo={bossesInfoDisplayed}
      infoPartners={infoPartnersDisplayed}
      infoQuizzes={infoQuizzes}
      infoActions={infoActions}
      submitInfo={onSubmitInfo}
      filterBosses={filterBosses}
      filterPartners={filterPartners}
      groupList={groupList}
      modulesCountry={modulesCountry}
      partnerModule={partnerModule}
      partnersQuizzesScore={partnersQuizzesScore}
      actionsAreas={actionsAreas}
    />
  )
}

export default IndicatorsContainer